export enum AppRoute {
 HOME = '/',
 LOGIN = '/login',
 SIGNUP = '/signup',
 VERIFYACCOUNT = '/verify-account',
 URLDESIGNER = '/url-designer/:cardId',
 URLTEMPLATEDESIGNER = '/enterprise/:cardId',
 //URLDESIGNER = '/pro/cards/url_designer',
 PORTFOLIO = '/portfolio/:id',
 PORTFOLIO_PREVIEW = '/portfolio/:id/:preview',
 MYCARDS = '/my-cards',
 MYPROFILE = '/my-profile',
 ANALYTICS = '/analytics',
 SETTINGS = '/settings',
}
